import { ButtonProps, ButtonState } from "./buttoncomponent";
import * as React from "react";
import { ButtonCSSStyle } from "./buttoncss";
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';


export class ButtonView extends UIComponentViewImpl<UIDataModel>{

    draw(uiProps: ButtonProps, uiState: ButtonState, cssStyle: ButtonCSSStyle): JSX.Element | boolean{
        super.draw(uiProps, uiState, cssStyle);
        
        return(
            <button style={uiState.style.getButtonStyle()} onClick={uiProps.onClick}>
                <label style={uiState.style.getButtonText()}>{uiState.label}</label><br/>
            </button> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/button/buttonview.tsx